import { FileAttachment } from '../model/attachment/file-attachment.model';
import { CommentState } from '../model/enum/comment-state.enum';
import { FileApi } from './../api/file.api';
import { Injectable } from '@angular/core';

@Injectable()
export class FileService {
  constructor(private fileApi: FileApi) {}

  getUserFiles = (offset?: number, limit?: number, searchBy?: string, sortBy?: string, ascending?:boolean) =>
    this.fileApi.getUserFiles(offset, limit,  searchBy, sortBy, ascending);

  getFilesForObservation = (observationType: number, observationId: string, commentState?: CommentState) =>
    this.fileApi.getFilesForObservation(observationType, observationId, commentState);

  getFile = (guid: string) => this.fileApi.getFile(guid);

  getFileBlob = (guid: string) => this.fileApi.getFileBlob(guid);

  getUserUsage = () => this.fileApi.getUserUsage();

  getFileResponse = (guid: string) => this.fileApi.getFileResponse(guid);

  getExport = (guid: string) => this.fileApi.getExport(guid);

  uploadFile = ({
    fileList,
    type,
    typeId,
    commentId,
    commentLabel,
  }: {
    fileList: FileList;
    type: number;
    typeId: string;
    commentId: string;
    commentLabel: string;
  }) =>
    this.fileApi.uploadFile({
      fileList,
      type,
      typeId,
      commentId,
      commentLabel,
    });

  uploadSignature = ({
    signature,
    type,
    typeId,
    subTypeId,
    portalId,
    fileId,
  }: {
    signature: Blob;
    type: number;
    typeId: string;
    subTypeId: number;
    portalId: number;
    fileId?: string;
  }) =>
    this.fileApi.uploadSignature({
      signature,
      type,
      typeId,
      subTypeId,
      portalId,
      fileId,
    });

  deleteFile = (file: FileAttachment) => this.fileApi.deleteFile(file);

  dataURItoBlob(dataURI: any) {
    let byteString: string = atob(dataURI.split(',')[1]);
    let mimeString: string = dataURI.split(',')[0].split(':')[1].split(';')[0];

    let ab: ArrayBuffer = new ArrayBuffer(byteString.length);
    let ia: Uint8Array = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }
}
